import { styled } from '@mui/material/styles';
import FixedFooter from '@components/Layout/FixedFooter';

export const Container = styled('div')({
    marginBottom: 65,
    '@media (max-width: 1024px)': {
        overflowY: 'auto',
        marginBottom: 80,
    },
});

export { FixedFooter as Footer };

export const Content = styled('div', {
    shouldForwardProp: prop => prop !== 'isPassword',
})(({ isPassword }) => ({
    maxWidth: '698px',
    display: 'grid',
    columnGap: '24px',
    rowGap: '16px',
    gridTemplateColumns: '1fr 1fr',
    ...(isPassword && { gridTemplateAreas: `"area1 area2" "area3 area4"` }),
    '@media (max-width: 1024px)': {
        gridTemplateColumns: '1fr',
        maxWidth: 'none',
        ...(isPassword && {
            gridTemplateAreas: `"area1" "area3" "area2" "area4"`,
            marginBottom: 0,
        }),
    },
}));
